import { render } from "./CreateOrResetPasswordView.vue?vue&type=template&id=483ce2ba"
import script from "./CreateOrResetPasswordView.vue?vue&type=script&lang=js"
export * from "./CreateOrResetPasswordView.vue?vue&type=script&lang=js"

import "./CreateOrResetPasswordView.vue?vue&type=style&index=0&id=483ce2ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__